<script setup lang="ts">
/**
 * Authored notifications flagged as a banner are shown at the top of the portal until
 * the user dismisses them. Dismissing marks the notification read — it stays in the
 * panel's read group and is not deleted.
 */
const { banners, markAsRead, label } = useNotifications();
</script>

<template>
  <div v-if="banners.length > 0" class="container mt-4">
    <PortalBanner
      v-for="notification in banners"
      :key="notification.id"
      class="mb-3"
      closable
      :color="
        notification.data.banner_style === 'critical' ? 'danger' : 'secondary'
      "
      :title="label(notification.data.title)"
      :description="label(notification.data.description)"
      @close="markAsRead(notification)"
    />
  </div>
</template>
